import { styled } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import MDTypography from 'components/MDTypography';
import Icon from '@mui/material/Icon';
import { Tooltip, tooltipClasses } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';

export const DashboardLeftGrid = styled(Grid)`
  justify-content: space-between;
`;

export const AnnouncementCard = styled(Card)`
  max-height: 495px;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 9px;
  }
  ::-webkit-scrollbar-thumb {
    background: #dcdcdc;
    border-radius: 10px;
  }
`;

export const HeadingTypography = styled(Typography)`
  padding: 16px 16px 0px 16px;
`;

export const AnnouncementsWrapper = styled(MDBox)`
  display: flex;
  align-items: flex-start;
  padding: 8px;
  line-height: 1;
`;

export const TitleTypography = styled(MDTypography)`
  margin-left: 8px;
  font-size: ${(props) => `${props.theme.palette.spacing[0] * 4}px`};
  font-weight: 400;
`;

export const DashboardSubHeader = styled(Box)`
  display: flex;
  z-index: 9;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  top: 0px;
  position: sticky;
  // background-color: #42424a;
  background-color: #4a90e2;
  border-radius: 10px 10px 0px 0px;
`;

export const SubHeadingTypography = styled(Typography)`
  color: #ffffff;
`;

export const DashboardCard = styled(Card)`
  position: sticky;
  height: 25vh;
  max-height: 25vh;
  overflow-y: scroll;
  border-radius: 0px 0px 10px 10px;
  ::-webkit-scrollbar {
    width: 9px;
  }
  ::-webkit-scrollbar-thumb {
    background: #dcdcdc;
    border-radius: 10px;
  }
`;

export const TypographyTable = styled(MDTypography)`
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 400;
`;

export const MyClassGrid = styled(Grid)`
  padding: 16px;
  //height: 30vh;
`;

export const Loader = styled(Box)`
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LinkWrapper = styled(MDBox)`
  display: flex;
  align-items: flex-start;
  padding: ${(props) => `${props.theme.palette.spacing[1] * 1}px `};
  line-height: 1;
  &:hover {
    background-color: ${(props) => props.theme.palette.background.default};
    border-radius: 8px;
  }
`;

export const LinkWrapperGrid = styled(Grid)`
  margin: ${(props) =>
    `${props.theme.palette.spacing[1] * 1}px ${props.theme.palette.spacing[1] * 0
    }px ${props.theme.palette.spacing[1] * 0}px ${props.theme.palette.spacing[1] * 1
    }px`};
`;

export const LightGrid = styled(Grid)`
  background: #f8f9fa;
  flex-direction: column;
  border-radius: ${(props) => `${props.theme.palette.spacing[0] * 1}px`};
  padding: ${(props) => `${props.theme.palette.spacing[1] * 2}px`};
  margin-bottom: ${(props) => `${props.theme.palette.spacing[1] * 2}px`};
`;

export const CardContainer = styled(Card)`
  padding: ${(props) => `${props.theme.palette.spacing[1] * 2}px`};
`;

export const ButtonWrapper = styled(Grid)`
  justify-content: end;
  padding: ${(props) =>
    `${props.theme.palette.spacing[0]}px ${props.theme.palette.spacing[0] * 2
    }px`};
`;

export const TimeOutGrid = styled(Grid)`
  padding: 8px 32px;
`;

export const SidenavIcon = styled(Icon)({
  marginTop: '8px',
});

export const ProfileBox = styled(MDBox)`
  display: flex;
  align-items: center;
`;
export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    border: '2px solid',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export const EventDetailsGrid = styled(Grid)`
  padding: 8px;
  flex-direction: column;
`;

export const CalendarEventButtonGrid = styled(Grid)`
  justify-content: space-between;
  align-items: center;
`;

export const ControlForm = styled(FormControl)`
  display: flex;
  width: 100%;
  margin-bottom: 10px;
`;

export const HelperTextForm = styled(FormHelperText)`
  color: #ff4d4f;
`;

export const DropdownLabelText = styled(InputLabel)`
  &.MuiInputLabel-root {
    ${(props) => (props.primary ? `color: #F44335` : '')};
  }
`;

export const HeadingGrid = styled(Grid)`
  padding: ${(props) =>
    `${props.theme.palette.spacing[1] * 0}px ${props.theme.palette.spacing[1] * 3
    }px`};
`;

export const GridWrapper = styled(Grid)`
  padding: ${(props) =>
    `${props.theme.palette.spacing[1] * 0}px ${props.theme.palette.spacing[1] * 2
    }px`};
`;

export const ButtonSpinnerProgress = styled(CircularProgress)`
  color: #1976d2;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
`;

export const ButtonSpinner = styled(Box)`
  display: flex;
  align-items: center;
`;

export const SubHeading = styled(Typography)`
  padding: 0px 24px 8px 24px;
`;

export const GridCenter = styled(Grid)`
  display: flex;
  justify-content: center;
`;

export const PGridCenter = styled(GridCenter)`
  padding: 10px 0px;
  ${(props) => (props.primary ? `display: none;` : '')};
`;

export const PSubHeading = styled(Typography)`
  padding: 4px 24px;
`;

export const ESubHeading = styled(PSubHeading)`
  color: #ff0000;
  font-size: ${(props) => `${props.theme.palette.spacing[1] * 2}px`};
`;

export const OutlinedButton = styled(Button)`
  ${(props) => (props.timeslotbutton ? `width: 112px;` : '')};
  ${(props) => (props.subjectbutton ? `width: 160px;` : '')};
  && {
    color: #344767;
    border: 1px solid;
    ${(props) => {
    if (props.available) {
      return `
      border-color: #4caf50;
      background-color: #e8f5e9;
        `;
    }
    if (!props.available && !props.subjectbutton) {
      return `
      border-color: #ef5350;
      background-color: #ffebee;
        `;
    }
    return '';
  }}
    &:hover {
      cursor: ${(props) => (!props.available && !props.subjectbutton ? 'not-allowed' : 'pointer')};
      opacity: unset;
      ${(props) => {
    if (props.available) return `background-color: #c8e6c9;`;
    if (!props.available && !props.subjectbutton) return `background-color: #ffcdd2;`;
    return '';
  }}
    }
    &[aria-pressed='true'] {
      color: white;
      border-color: #344767;
      background-color: #344767;
    }
    &.Mui-disabled {
      opacity: 0.7;
      color: #344767;
      border-color: #ef5350;
      background-color: #ffebee;
    }
  }
`;

export const TruncatedText = styled('span')`
width: 100%;
display: block;
overflow: hidden;
white-space: nowrap;
  text-overflow: ellipsis;
`;

export const BorderGrid = styled(Grid)`
  border: 1px solid;
  border-radius: ${(props) => `${props.theme.palette.spacing[1] * 1}px`};
`;

export const CardWrapper = styled(Card)`
  border-radius: 0px 0px 10px 10px;
`;

export const FullCard = styled(CardWrapper)`
  height: ${(props) => `${props.theme.palette.spacing[1] * 11}%`};
  justify-content: center;
`;

export const TimeSlotGrid = styled(Grid)`
  ${(props) => (props.primary ? `justify-content: center;` : '')};
`;

export const GridHeading = styled(Grid)`
  padding: ${(props) =>
    `${props.theme.palette.spacing[1] * 1}px ${props.theme.palette.spacing[1] * 3
    }px`};
`;

export const LaunchGrid = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  justify-items: center;
  padding: 10px 15px;
`;

export const LaunchCard = styled(Box)`
  background: ${(props) => props.gradient};
  border-radius: 12px;
  padding: 25px 15px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  text-decoration: none;
  color: white;
  position: relative;
  overflow: hidden;
  // min-height: 160px;
  height: 100px;
  width: 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: pulse 3s ease-in-out infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
      opacity: 0.5;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.8;
    }
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  }
`;

export const LaunchIcon = styled(Box)`
  width: 40px;
  height: 40px;
  margin-bottom: -5px;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  }
`;

export const LaunchLabel = styled(Box)`
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  word-wrap: break-word;
  line-height: 1.3;
  margin-top: 4px;
  max-width: 100px;
`;

export const StyledSelect = styled(Select)`
  & .MuiSelect-select {
    display: block;
    text-align: left;
    padding-left: 0px;
  }
`;
export const NoInfoGrid = styled(Grid)`
  height: 100%;
  align-content: center;
  justify-content: center;
`;

export const TypographyText = styled(MDTypography)`
  font-size: 14px;
  margin-left: 8px;
  font-weight: 400;
`;